(function () {
	'use strict';
	angular.module('app.setup')
		.controller('dataPipelineSummary', dataPipelineSummary);

	dataPipelineSummary.$inject = ['$rootScope', '$scope', '$location', '$timeout', 'siteService', 'columnsService', 'leanFilterService', 'tableService', 'URLS', '$experiments'];

	function dataPipelineSummary($rootScope, $scope, $location, $timeout, siteService, columnsService, leanFilterService, tableService, URLS, $experiments) {

		var vm = this;
		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.reportName = 'Data Sync Status';
		vm.useReactReport = $experiments.isEnabled('react-data-sync');

		var noOfCustomers = siteService.getCustomersCount();

		$timeout(function(){
			jQuery('li.list-group-item.selected').removeClass('selected');
			jQuery('#supplyChainDataPipeline').addClass('selected');
		}, 0);
		var defaultFilters = [{
			'id': 'allFactory',
			'values': [leanFilterService.leanDnaAllSelected],
			'isMandatory': true
		}];

		init();

		function getMeta() {
			return meta;
		};

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams)
				.then(function(response) {
					for(var i=0; i<response[0].length; i++) {
						// Clean up newline at end of instanceIds
						if(response[0][i].instanceId) {
							response[0][i].instanceId = response[0][i].instanceId.trim();
						}
						response[0][i].leanSync = vm.leanSync;
					}
					return response;
				})
				.catch(function(response) {
					$rootScope.$emit('toast', {
						'message': 'An error occurred while retrieving data.',
						'success': false
					});
					return [response.data];
				});
		}

		function init() {
			leanFilterService.clearFilters();

			var multiSelectFilters = [];
			var factoriesFilter = leanFilterService.filterDefinitions['AllFactories'];
			if (!$rootScope.authz.isLeanDNAAdmin()) {
				factoriesFilter = _.assign({}, factoriesFilter, {sendAllValues: true, url: URLS.factories + '?includeSupplier=true&sameCustomer=true&opsFactNdx=' + globalConfig.factory.id, label: 'alias'});
			} else {
				factoriesFilter = _.assign({}, factoriesFilter, {sendAllValues: true});
			}
			factoriesFilter.removable = false;
			multiSelectFilters.push(factoriesFilter);
			multiSelectFilters.push(leanFilterService.filterDefinitions['WorkerType']);
			multiSelectFilters.push(leanFilterService.filterDefinitions['WorkerState']);
			leanFilterService.setMasterFilterList(multiSelectFilters);

			leanFilterService.setMasterRangeFilterList([
				leanFilterService.filterDefinitions['DateRequested'],
				leanFilterService.filterDefinitions['DateStarted'],
				leanFilterService.filterDefinitions['DateEnded']
			]);
		}

		var columns = columnsService({
			factoryNdx: 0,
			customer: {
				disabled: noOfCustomers === 0
			},
			factory: 1,
			type: 1,
			action: 1,
			status: 1,
			statusDetail: 1,
			statusDetailInternal: 1, // note that the column in data-pipeline-columns.service.js has a conditional based on leandna admin
			instanceId: 0,
			dateRequest: 1,
			waitTime: 1,
			dateStart: 1,
			runTime: 1,
			dateEnd: 1,
			requestor: 0,
			lastSuccessfulJobDate: 1,
			dateEndEst: 0,
			dateEndStageEst: 0
		});
	
		var meta = {
			noPaging: true,
			reportUrl: '{0}/WorkerQueue/Jobs', 
			columns: columns,
			defaultSort: 'dateRequest',
			defaultSortDirection: 'desc',
			defaultFilters: defaultFilters,
			pinnedColumns: [],
			reportSettingsName: 'DataPipeline',
			hideSearch: true,
			extraParams: [{excelReportName: 'DataPipeline'}],
			rendererParams: {},
			setColumnDefaults: true,
			isGlobalReportSetting: true
		};
	}
})();
